module.exports = __webpack_public_path__ + "img/clienti.6be5da5e.svg";